import { convertClass, convertTypeString, dateFormation, fixedNumber } from "../common/cores";

export const sportPerPage = 100;
export const perPage = 100;

export const SiteName = "DogBet";
export const SiteNameKor = "도지 BET";
export const Telegram = "/";

export const getHisList = (list, type) => {
    let rate = getRate(list, type)
    switch (type) {
        case "slot":
            return { 
                date: dateFormation(list.created_date, 9),
                rate: "_",
                betMoney: Number(list.amount).toLocaleString(),
                resultMoney: (Number(list.amount) * rate).toLocaleString(),
                className: convertClass(list.type),
                type: convertTypeString(list.type)
            };
    
        case "casino":
            return { 
                date: dateFormation(list.created_date, 9),
                rate: "_",
                // betMoney: Math.abs(Number(list.amount)).toLocaleString(),
                betMoney: Number(list.amount).toLocaleString(),
                resultMoney: (Math.abs(Number(list.amount)) * rate).toLocaleString(),
                className: convertClass(list.type),
                type: convertTypeString(list.type)
            };

        case "minigame":
            return { 
                date: dateFormation(list.created_date, 9),
                rate: list.rate,
                betMoney: Number(list.balance.bet).toLocaleString(),
                resultMoney: (Number(list.balance.bet) * rate).toLocaleString(),
                className: convertClass(list.type),
                type: convertTypeString(list.type)
            };

        default:
            return { 
                date: dateFormation(list.created_date, 9),
                rate: fixedNumber(Number(list.rate)),
                betMoney: Number(list.balance.bet).toLocaleString(),
                resultMoney: (Number(list.balance.bet) * rate).toLocaleString(),
                className: convertClass(list.type),
                type: convertTypeString(list.type)
            };
    }
}

export const getRate = (list, type) => {
switch (type) {
    case "slot":
        return  0;

        case "casino":
            return 0;

        case "minigame":
            return fixedNumber(Number(list.odd.rate));

        default:
            return fixedNumber(Number(list.rate));
    }
}


export const ChangeNum_Letter = (data) => {

    let unit = [100000000, 10000, 1000, 100, 10], letter = ['억', '만', '천', '백', '십']
    let result = ``
    let index = 0;
    while (data) {
        if (index == 5) {
            if (data > 0) {
                result += data
            }
            break;
        }
        if (data / unit[index] >= 1) {
            result += (parseInt(data / unit[index]) + letter[index]).toString()
            data %= unit[index]
        }
        index++;
    }
    return result;
}

export const RemoveLocal = () => {
    localStorage.removeItem("bettingItem");
    localStorage.removeItem("sportsId");
    localStorage.removeItem("eventkey");
}



// WEBPACK FOOTER //
// ./src/utils/index.js